import { render } from "./company-systems.vue?vue&type=template&id=4303622e&ts=true"
import script from "./company-systems.vue?vue&type=script&lang=ts"
export * from "./company-systems.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__